import { useIdleCallback } from './hooks.mjs';

function OnIdle({
  perform,
  unsupportedBehavior
}) {
  useIdleCallback(perform, {
    unsupportedBehavior
  });
  return null;
}

export { OnIdle };
